(function(){
    angular
        .module('maApp.core')
        .config(routes);

    routes.$inject = ['$routeProvider'];

    function routes($routeProvider) {
        $routeProvider
            .when('/', {
                controller: 'ActualsUnplannedController',
                controllerAs:'vm',
                templateUrl: 'app/view/pages/actualsunplanned/ActualsUnplanned.html',
                title: 'Home',
                permissions: []
            })
            .when('/project/:project', {
                controller: 'ActualsUnplannedController',
                controllerAs:'vm',
                templateUrl: 'app/view/pages/actualsunplanned/ActualsUnplanned.html',
                title: 'Home',
                permissions: []
            })

            // Enter actuals for unplanned action
            // (note: keep this route from older version to support any bookmarks)
            .when('/project/:project/actualsunplanned', {
                controller: 'ActualsUnplannedController',
                controllerAs:'vm',
                templateUrl: 'app/view/pages/actualsunplanned/ActualsUnplanned.html',
                title: 'Home',
                permissions: []
            })

            //Catch All
            .otherwise({
                controller:'CatchAllController',
                controllerAs:'vm',
                templateUrl:'app/view/pages/catchall/CatchAll.html',
                title:'Page Not Found'
            })
        ;
    }
})();